<script lang="ts" setup>
const {
  public: { webAppLink },
} = useRuntimeConfig()

const { t } = useI18n()
</script>

<template>
  <NuxtLink
    target="_blank"
    :to="webAppLink"
    aria-label="Launch Web App"
    class="border-2 border-solid border-white rounded-full flex flex-row items-center gap-2.5 px-3.5 py-2.5 h-14 justify-center uppercase whitespace-pre"
  >
    <img alt="App" src="/assets/images/icons/website.svg" />
    {{ t('web-app') }}
  </NuxtLink>
</template>
